module.exports = __webpack_public_path__ + "img/apidays-hongkong-2022-participants.f86da34d.jpg";